// Valide que la raison sociale n'est pas vide et fait au moins 2 caractères
export function validateCompanyName(name) {
    return typeof name === 'string' && name.trim().length > 1;
}

// Valide que la forme juridique n'est pas vide et correspond à une des valeurs connues
export function validateLegalForm(form) {
    const legalForms = [
        'ASSOCIATION', 'EI', 'EURL', 'SARL', 'SA', 'SCOP', 'SNC', 'SAS', 'SASU', 'O'
    ];
    return typeof form === 'string' && legalForms.includes(form.toUpperCase());
}

// Valide que le SIREN est une chaîne de 9 chiffres
export function validateSiren(siren) {
    return typeof siren === 'string' && /^\d{9}$/.test(siren);
}
import moment from "moment";
import _ from "lodash";
import config from "./config";
import axios from "axios";

export function copyToClipboard(text) {
    try {
        navigator.clipboard.writeText(text);
        return false;
    } catch (e) {
        console.error(e);
        return false;
    }
}


export function capitalizeFirstLetter(string) {
    if (typeof string !== "string") {
        return "";
    }

    return string?.charAt(0).toUpperCase() + string?.slice(1);
}

export function formatJson(data) {
    if (!data) {
        return "";
    }

    try {
        let j = JSON.stringify(data, null, 4);
        return j;
    } catch {
        return data;
    }
}

// TODO: Bouger les fonctions format dans format.js

export function formatDateFr(date, datetime = false, seconds = true) {
    return moment(date).format(`DD/MM/YYYY ${datetime ? `HH:mm:${seconds ? "ss" : ""}` : ""}`);
}

export function formatEuro(number) {
    if (typeof number === "string") {
        number = parseFloat(number);
    }
    const euroFormatter = new Intl.NumberFormat("fr-FR", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 2,
    });
    return euroFormatter.format(number);
}

export async function validateIban(iban) {

    if (typeof iban !== "string" && !iban?.length >= 14 && iban?.length <= 34) {
        return false;
    }
    return await trullyValidateIban(iban);


}

export async function trullyValidateIban(iban) {
    // Si CHECK_IBAN est true, on ne fait pas de vérification openiban
    if (!config.check_iban) {
        // Mode manuel: on accepte l'IBAN s'il a une longueur valide
        return iban?.length >= 14 && iban?.length <= 34;
    }

    try {
        const response = await axios.get(`https://openiban.com/validate/${iban}`);

        if (response.data.valid) {
            return true;
        } else {
            return false;
        }
    } catch (e) {
        console.error(e);
        return false;
    }
}

export function validateBic(bic) {
    if (typeof bic !== "string") {
        return false;
    }

    return bic?.length === 8 || bic?.length === 11;
}

export function validateFirstname(firstname) {
    if (typeof firstname !== "string") {
        return false;
    }

    return firstname?.length > 1;
}

export function validateLastname(lastname) {
    if (typeof lastname !== "string") {
        return false;
    }

    return lastname?.length > 1;
}

export function validateZipcode(zipcode) {
    if (typeof zipcode !== "string") {
        return false;
    }

    return zipcode.length === 5;
}

export function validateGender(gender) {
    if (typeof gender !== 'string') {
        return false;
    }

    const genders = ['m', 'f', 's'];

    return genders.includes(gender?.toLowerCase());
}

export function validateEmail(email) {
    if (typeof email !== "string") {
        return false;
    }

    const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return email.length > 1 && regexEmail.test(email);
}

export function validateCity(city) {
    if (typeof city !== "string") {
        return false;
    }

    return city.length > 1;
}

export function validateBirthdate(birthdate) {
    if (typeof birthdate !== "string") {
        return false;
    }

    return moment(birthdate).isValid() && moment(birthdate).isAfter(moment().subtract(120, "years"));
}

export function validateAddress(address) {
    if (typeof address !== "string") {
        return false;
    }

    return address.length > 1;
}

export function validateMobilePhone(mobilePhone) {
    if (typeof mobilePhone !== "string") {
        return false;
    }

    const mobilePhoneRegex = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/;

    return mobilePhoneRegex.test(mobilePhone);
}

export function getConfig() {
    return config;
}

export function camelToSnakeCase(str) {
    return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
}

export function validateLicensePlate(str) {
    const regexPlaqueImmatriculation = /^(\d{2,3}-?[A-Z]{2}-?\d{2}|\d{3}-?[A-Z]{3}-?\d{2}|[A-Z]{1,2}-?\d{2,3}-?[A-Z]{1,3}|[A-Z]-?\d{2}-?[A-Z]{1})$/;


    if (regexPlaqueImmatriculation.test(str)) {
        return true;
    } else {
        return false;
    }
}

export function validateStartDate(date) {
    date = moment(date);
    let diff = moment().diff(date, "days");

    if (diff > 0) {
        return false;
    }

    if (diff > 180) {
        return false;
    }

    return true;
}

export function validatePreviousPolicStartDate(date) {
    date = moment(date);
    let diff = moment().diff(date, "days", true);

    if (diff <= 365) {
        return false;
    }

    return true;
}

export function getAgeFromDate(date) {
    return moment().diff(date, "years");
}

export function handleValidationErrors(error) {
    if (error.response && error.response.status === 422 && error.response.data.errors) {
        return Object.keys(error.response.data.errors).reduce((acc, key) => {
            acc[key] = error.response.data.errors[key].join(' ');
            return acc;
        }, {});
    }
    // Pour les autres types d'erreurs, renvoyer un message générique ou manipuler comme désiré
    return { general: 'Une erreur est survenue.' };
};

/**
 * This code is licensed under the terms of the MIT license
 *
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */
export function difference(object, base) {
    function changes(object, base) {
        return _.transform(object, function (result, value, key) {
            if (!_.isEqual(value, base[key])) {
                result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
            }
        });
    }
    return changes(object, base);
}
